import { render, staticRenderFns } from "./newBabyBarn.vue?vue&type=template&id=22eb2326&scoped=true"
import script from "./newBabyBarn.vue?vue&type=script&lang=js"
export * from "./newBabyBarn.vue?vue&type=script&lang=js"
import style0 from "./newBabyBarn.vue?vue&type=style&index=0&id=22eb2326&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eb2326",
  null
  
)

export default component.exports